export const SKIN_COLOR = Object.freeze([
  Object.freeze({
    text: 'Branca',
    value: 'WHITE',
  }),
  Object.freeze({
    text: 'Preta',
    value: 'BLACK',
  }),
  Object.freeze({
    text: 'Amarela',
    value: 'YELLOW',
  }),
  Object.freeze({
    text: 'Parda',
    value: 'BROWN',
  }),
  Object.freeze({
    text: 'Indígena',
    value: 'INDIGENOUS',
  }),
])

export const PATIENT_ORIGIN = Object.freeze([
  Object.freeze({
    text: 'Chatbot',
    value: 'CHATBOT',
  }),
  Object.freeze({
    text: 'Facebook',
    value: 'FACEBOOK',
  }),
  Object.freeze({
    text: 'Google',
    value: 'GOOGLE',
  }),
  Object.freeze({
    text: 'Indicação',
    value: 'INDICACAO',
  }),
  Object.freeze({
    text: 'Instagram',
    value: 'INSTAGRAM',
  }),
  Object.freeze({
    text: 'Jornal',
    value: 'JORNAIS',
  }),
  Object.freeze({
    text: 'Revistas',
    value: 'REVISTAS',
  }),
  Object.freeze({
    text: 'TV',
    value: 'TV',
  }),
  Object.freeze({
    text: 'WhatsApp',
    value: 'WHATSAPP',
  }),
  Object.freeze({
    text: 'Outros',
    value: 'OUTROS',
  }),
])

export const ASSIGNED_SEX = Object.freeze([
  Object.freeze({
    text: 'Masculino',
    value: 'MALE',
  }),
  Object.freeze({
    text: 'Feminino',
    value: 'FEMALE',
  }),
  Object.freeze({
    text: 'Intersexo',
    value: 'INTERSEX',
  }),
])

export const EAssignedSexText = {
  MALE: 'Masculino',
  FEMALE: 'Feminino',
  INTERSEX: 'Intersexo',
}
